import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const base = API_BASE_URL;

/** Currently configured percentage for a given Issue/Receive type (used to prefill Edit) */
export const getItemDepByType = (Type) =>
    axios.get(`${base}/Purchase/GetItemDepByType`, { params: { Type } });

/** Grid of all configured item depreciation percentages (one row per Type) */
export const getAllItemDepPercentage = () =>
    axios.get(`${base}/Purchase/GetAllItemDepPercentage`);

/** Add / Edit / Delete the depreciation percentage for a Type */
export const saveItemDepreciationPercent = ({ Percentage, Type, Action, CreatedBy, RoleId }) =>
    axios.post(`${base}/Purchase/SaveItemDepreciationPercent`, {
        Percentage,
        Type,
        Action,
        CreatedBy,
        RoleId,
    });
